import { IKeHoachKyActionTypes } from "../../action-types/ke-hoach/IKeHoachKyActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachKyReducer } from "../../reducer-model/ke-hoach/IKeHoachKyReducer";
const iniState: IKeHoachKyReducer = {
  status: eReducerStatusBase.is_not_initialization,
  keHoachKys: [],
  namHoc: "",
  idKh: 0
};
export const keHoachKyReducer = (
  state: IKeHoachKyReducer = iniState,
  action: IKeHoachKyActionTypes
): IKeHoachKyReducer => {
  switch (action.type) {
    case "KE_HOACH_KY_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        namHoc: action.payload
      };
    case "KE_HOACH_KY_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachKys: action.payload,
      };
    case "KE_HOACH_KY_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KE_HOACH_KY_SHOW_EDIT_MODAL":
      return {
        ...state,
        keHoachKyEditing: action.payload,
        isShowEditModal: true
      };
    case "KE_HOACH_KY_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false
      };
    case "KE_HOACH_KY_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "KE_HOACH_KY_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "KE_HOACH_KY_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "KE_HOACH_KY_UPDATE_LOCK_STATUS_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "KE_HOACH_KY_UPDATE_LOCK_STATUS_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "KE_HOACH_KY_UPDATE_LOCK_STATUS_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "KE_HOACH_KY_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "KE_HOACH_KY_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "KE_HOACH_KY_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };


    default:
      return state;
  }
};
